module.exports = (func, explicitName) => (...args) => {
  // eslint-disable-next-line no-console
  console.verbose(
    `wix-dataset ${explicitName} was called with ${JSON.stringify(args)}`
  )
  try {
    const result = func(...args)
    // eslint-disable-next-line no-console
    console.verbose(
      `wix-dataset ${explicitName} response ${JSON.stringify(result)}`
    )
    return result
  } catch (e) {
    // eslint-disable-next-line no-console
    console.verbose(`wix-dataset ${explicitName} response ${e}`)
    throw e
  }
}



// WEBPACK FOOTER //
// ./dataset-controller/verboseWrapper.js